import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_3 = { class: "flex items-center justify-center min-h-full text-center sm:p-0" }
const _hoisted_4 = {
  class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-max m-2",
  id: "popupQR"
}
const _hoisted_5 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_6 = { class: "modal-content bg-black-body text-white" }
const _hoisted_7 = { class: "modal-body text-justify z-50 relative" }
const _hoisted_8 = { class: "border-0 text-center" }
const _hoisted_9 = { class: "p-3 md:p-10" }
const _hoisted_10 = { class: "flex flex-col items-center mb-4" }
const _hoisted_11 = { class: "space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        ($props.displayConfirmDeleteModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        ($props.displayConfirmDeleteModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('closeConfirmDeleteModal')), ["prevent"]))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", null, "Confirm Deletion of " + _toDisplayString($props.version) + " Release?", 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-white text-center rounded-md duration-150 transition-all bg-red-800 hover:bg-red-600 px-10 py-2 text-sm",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.confirmedButtonPressed()))
                              }, "Confirm"),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-white text-center rounded-md duration-150 transition-all bg-gray-600 hover:bg-gray-500 px-10 py-2 text-sm",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('closeConfirmDeleteModal')), ["prevent"]))
                              }, "Cancel")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}